import { whenDocumentReady } from '../../../../../paws/assets/frontend/js/helper/documentready';

whenDocumentReady(initModule);
function initModule() {

    window.slider = document.querySelector('[paws-component="noss-nslider"]');
    if (slider !== null) {
        window.slides = Array.from(window.slider.querySelectorAll('[paws-component="noss-nslideitem"]'));
        window.contents = window.slides.map((slide) =>
            slide.querySelector(".content")
        );

        window.previewWidthDesktop = 100;
        window.previewWidthMobile = 70;

        initSlider();
        window.addEventListener("resize", initSlider);
        window.addEventListener("scroll", updateSlides, {passive: true});
    }
}
function initSlider() {
    setSectionHeight();
    updateSlides();
}

function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
}

function lerp(start, end, t) {
    return start + (end - start) * t;
}

function smoothstep(t) {
    return t * t * (3 - 2 * t);
}

function getPreviewVisibleWidth() {
    return window.innerWidth <= 900
        ? window.previewWidthMobile
        : window.previewWidthDesktop;
}

function getSlideSlant() {
    const ratio = window.innerWidth <= 900 ? 0.08 : 0.10;
    const raw = window.innerWidth * ratio;
    return clamp(raw, 40, 140);
}

function setSectionHeight() {
    if (window.slides != null) {
        const sectionHeight = window.innerHeight * window.slides.length;
        window.slider.style.height = `${sectionHeight}px`;
    }
}

function updateSlides() {
    const previewVisibleWidth = getPreviewVisibleWidth();
    const slideSlant = getSlideSlant();
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;

    window.slider.style.setProperty("--nslide-slant", `${slideSlant}px`);

    const rect = slider.getBoundingClientRect();
    const sliderTop = window.scrollY + rect.top;
    const sliderHeight = window.slider.offsetHeight;
    const maxScroll = sliderHeight - viewportHeight;

    const localScroll = clamp(window.scrollY - sliderTop, 0, maxScroll);
    const overallProgress = maxScroll > 0 ? localScroll / maxScroll : 0;

    const segmentCount = window.slides.length - 1;
    const rawSegment = overallProgress * segmentCount;

    const currentIndex = clamp(
        Math.floor(rawSegment),
        0,
        window.slides.length - 1
    );
    const nextIndex = clamp(currentIndex + 1, 0, window.slides.length - 1);

    const linearProgress = clamp(rawSegment - currentIndex, 0, 1);
    const segmentProgress = smoothstep(linearProgress);

    const expandedVisibleWidth =
        viewportWidth - (window.slides.length - 1) * previewVisibleWidth;

    const visibleWidths = new Array(window.slides.length).fill(previewVisibleWidth);

    if (currentIndex === window.slides.length - 1) {
        visibleWidths[currentIndex] = expandedVisibleWidth;
    } else {
        visibleWidths[currentIndex] = lerp(
            expandedVisibleWidth,
            previewVisibleWidth,
            segmentProgress
        );

        visibleWidths[nextIndex] = lerp(
            previewVisibleWidth,
            expandedVisibleWidth,
            segmentProgress
        );
    }

    window.slides.forEach((slide, index) => {
        const actualWidth =
            visibleWidths[index] + (index === 0 ? 0 : slideSlant);

        slide.style.width = `${actualWidth}px`;
    });

    window.contents.forEach((content, index) => {
        let visibility = 0;

        if (currentIndex === window.slides.length - 1) {
            visibility = index === currentIndex ? 1 : 0;
        } else if (index === currentIndex) {
            visibility = 1 - segmentProgress;
        } else if (index === nextIndex) {
            visibility = segmentProgress;
        } else {
            visibility = 0;
        }

        content.style.opacity = visibility;
        content.style.transform = `translateY(${(1 - visibility) * 16}px)`;
        content.style.pointerEvents = visibility > 0.85 ? "auto" : "none";
    });
}